import React, { useEffect, useState } from "react";
import "./admin.css";
import "./lawyers.css";
import { toast } from "react-toastify";
import { getDatabase, ref, onValue, update, Child } from "firebase/database";

function LawyerRequest() {
  let [Lawyersarr, setLawyersarr] = useState([]);

  useEffect(() => {
    const db = getDatabase();
    const starCountRef = ref(db, "/requests");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        if (element.val().business_Uid === sessionStorage.getItem("uid")) {
          arr.push(element.val());
        }
      });
      setLawyersarr(arr);
    });
  }, []);

  let SetApproval = (id) => {
    const db = getDatabase();
    const starCountRef = ref(db, `/requests/` + id);
    update(starCountRef, { approved: "Approved" })
      .then(() => {
        console.log("Updated done");
      })
      .catch((e) => {
        console.log(e);
      });
  };



  let Reject = (id) => {
    const db = getDatabase();
    const starCountRef = ref(db, `/requests/` + id);
    update(starCountRef, { approved: "Not Approved" , response : 'yes'})
      .then(() => {
        console.log("Updated done");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <div className="divwala">
        <div>
          <div>
            <table className="admin-data">
              <thead className="ishtyle">
                <tr>
                  <th>Coustomer Name</th>
                  <th>Coustomer Email</th>
                  <th>Case Type</th>
                  <th>Sub Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Lawyersarr.map((val, index) => {
  return (
    <tr key={index}>
      <td>{val.client_name}</td>
      <td>{val.client_email}</td>
      <td>{val.Type_select}</td>
      <td>{val.subType_Select}</td>
      {val.approved === "Not Approved" && val.response === 'no'  ? (
        <>
          <button
            // className="actbtn"
            style={{
              backgroundColor: "#888",
              fontWeight: "bold",
            }}
            onClick={() => SetApproval(val.uid)}
          >
            Accept
          </button>
          <button
            style={{
              backgroundColor: "red",
              fontWeight: "bold",
            }}
            onClick={() => Reject(val.uid)}
  
          >
            Reject
          </button>
        </>
      ) :(val.approved === "Not Approved" && val.response === 'yes') ?
      <td style={{ color: "green" }}>Rejected</td>

      :
      
      (
        <td style={{ color: "green" }}>Approved</td>
      )}
    </tr>
  );



})}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default LawyerRequest;
